import React, {Component} from "react";

export default ({width, height}) => (OriginalComponent) =>
  class DecoratedComponent extends Component {
    state = {
      transform: `scale(1)`,
      height: `auto`
    };
    componentDidMount() {
      if (window) {
        this.scale();
        window.addEventListener(`resize`, this.scale);
      }
    }
    componentWillUnmount() {
      if (window) {
        window.removeEventListener(`resize`, this.scale);
      }
    }
    scale = () => {
      const side = width > height ? width : height;
      const windowWidth = window.innerWidth;
      const minWidth = 320;
      const scaleVal =
        windowWidth > minWidth ? windowWidth / side : minWidth / side;
      const tx = (width - width * scaleVal) / 2 / scaleVal;
      const ty = (height - height * scaleVal) / 2 / scaleVal;
      this.setState({
        transform:
          scaleVal > 1
            ? `scale(1)`
            : `scale(${scaleVal}) translate(-${tx}px, -${ty}px)`,
        height: scaleVal > 1 ? `auto` : height * scaleVal
      });
    };
    render() {
      const {transform, height: heightContainer} = this.state;
      return (
        <div style={{height: heightContainer}}>
          <div
            style={{
              width,
              height,
              margin: `0 auto`,
              transform
            }}
          >
            <OriginalComponent {...this.props} {...this.state} />
          </div>
        </div>
      );
    }
  };
